import { isFunction } from './common';

/**
 * Intercept/hook any method/property call in a class/object.
 * This will not change nothing in the original object.
 *
 * Ex: window.seamlessStore.store = hook(window.seamlessStore.store, () => any );
 *
 * @param  {Record} obj Object/Class to intercept
 * @param  {() => any} fn Callback
 * @return {any}
 */
export function hook(obj: Record<string | symbol, any>, fn: (...args: any[]) => any): any {
  return new Proxy(obj, {
    get(target, prop) {
      if (isFunction(target[prop])) {
        return new Proxy(target[prop], {
          apply: (target, thisArg, argumentsList) => {
            // Run anything before the original method
            fn(target, prop, argumentsList);

            return Reflect.apply(target, thisArg, argumentsList);
          },
        });
        // biome-ignore lint/style/noUselessElse: <explanation>
      } else {
        fn(target, prop);
        return Reflect.get(target, prop);
      }
    },
  });
}
